<template>
  <div :class="bgFrom">
    <div class="pt-12 sm:pt-16 lg:pt-20">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div v-motion-pop-visible-once class="text-center">
          <h2 class="text-3xl font-extrabold text-gray-900 sm:text-4xl lg:text-5xl">
            {{ __('Fair & Cheap') }}
          </h2>
          <p class="mt-4 text-xl text-gray-600">
            {{ __('If you\'re not satisfied, contact us within the first 14 days and we\'ll send you a full refund.') }}
          </p>
        </div>
      </div>
    </div>
    <div class="mt-8 sm:mt-12" :class="bgTo">
      <div class="relative">
        <div class="absolute inset-0 h-1/2" :class="bgFrom" />
        <div class="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div class="max-w-lg mx-auto rounded-lg border border-gray-100 overflow-hidden lg:max-w-none lg:flex">
            <div class="flex-1 bg-white px-6 py-8 lg:p-12">
              <h3 v-motion-pop-visible-once class="text-2xl font-extrabold text-gray-900 sm:text-3xl">
                {{ __('Smart Plan') }}
              </h3>
              <p v-motion-pop-visible-once class="mt-6 text-base text-gray-500">
                {{ __('Incident communication to customers provides a level of trust, always be transparent with incidents.') }}
              </p>
              <div v-motion-pop-visible-once class="mt-8">
                <div class="flex items-center">
                  <h4 class="flex-shrink-0 pr-4 bg-white text-sm tracking-wider font-semibold uppercase text-primary-600">
                    {{ __('What\'s included') }}
                  </h4>
                  <div class="flex-1 border-t-2 border-gray-200" />
                </div>
                <ul role="list" class="mt-8 space-y-5 lg:space-y-0 lg:grid lg:grid-cols-2 lg:gap-x-8 lg:gap-y-5">
                  <li
                      v-motion
                      :initial="{ x: -100, opacity: 0 }"
                      :visibleOnce="{ x: 0, opacity: 1 }"
                      :delay="(iX+1)*300"
                      v-for="(feature, iX) in includedFeatures"
                      :key="feature"
                      class="flex items-start lg:col-span-1"
                  >
                    <div class="flex-shrink-0">
                      <CheckCircleIcon class="h-5 w-5 text-green-400" aria-hidden="true" />
                    </div>
                    <p class="ml-3 text-sm text-gray-700">
                      {{ __(feature) }}
                    </p>
                  </li>
                </ul>
              </div>
            </div>
            <div class="py-8 px-6 text-center bg-gray-50 lg:flex-shrink-0 lg:flex lg:flex-col lg:justify-center lg:p-12">
              <p v-motion-pop-visible-once class="text-lg leading-6 font-medium text-gray-900">
                {{ __('For each budget') }}
              </p>
              <div v-motion-pop-visible-once class="mt-4 flex items-center justify-center text-5xl font-extrabold text-gray-900">
                                            <span>
                                                4,99
                                            </span>
                <span class="ml-3 text-xl font-medium text-gray-500">
                                              EUR
                                            </span>
              </div>
              <p v-motion-pop-visible-once class="mt-4 text-sm">
                <a target="_blank" href="https://help.livck.com" class="font-medium text-gray-500 underline">
                  {{ __('Learn more about our statuspage') }}
                </a>
              </p>
              <div v-motion-pop-visible-once class="mt-6">
                <inertia-link :href="route('pricing')" class="w-full shadow text-center px-5 py-3 border border-transparent text-sm font-medium rounded-md text-white bg-primary hover:bg-primary-600">
                  {{ __('Get Pricing') }}
                </inertia-link>
              </div>
              <div v-motion-pop-visible-once class="mt-4 text-sm">
                <a target="_blank" href="https://demo.livck.com" class="font-medium text-gray-900">
                  {{ __('See a demo statuspage') }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {defineComponent, h} from "vue";
import {CheckCircleIcon} from '@heroicons/vue/solid'

export default {
  name: "CheapPackagePreviewBox",
  components: {
    CheckCircleIcon
  },
  props: {
    bgFrom: {
      type: String,
      default: 'bg-gray-50'
    },
    bgTo: {
      type: String,
      default: 'bg-gray-100'
    },
  },
  data() {
    return {
      checkedIcon: defineComponent({
        render() {
          return h('svg', {
            xmlns: 'http://www.w3.org/2000/svg',
            viewBox: '0 0 37.38 45.98'
          }, [
            h('path', {
              fill: 'currentColor',
              d: 'M23.54,0l-8,32.44L12.87,21.69H0L7.32,46H23.4l14-46Z'
            })
          ]);
        }
      }),
      includedFeatures: [
        'Public/Private Statuspage', // __('Public/Private Statuspage')
        'Self-Hosted',
        'Announcement Management', // __('Announcement Management')
        'Newsletter', // __('Newsletter')
        'Notifications', // __('Notifications')
        'API', // __('API')
      ],
    };
  }
}
</script>